import styled from "styled-components";

export const ContentTexts = styled.div`
  padding-bottom: 4rem;

  @media (max-width: 768px) {
    padding-bottom: 3rem;
  }
`;

export const BackText = styled.p`
  padding-bottom: .75rem;
  font-size: 1rem;
  color: var(--color_lightGray);
  font-family: FiraSans;
  line-height: 1.8;
`;
